import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Button, Grid } from "@mui/material";
import theme from "Theme/AppTheme";

interface IDataGridVisibilityToggle {
    isDataGridVisible: boolean;
    onToggle: () => void;
}

export const DataGridVisibilityToggle = ({
    isDataGridVisible,
    onToggle,
}: IDataGridVisibilityToggle) => (
    <Grid
        item
        container
        xs={12}
        justifyContent="center"
        sx={{
            paddingTop: isDataGridVisible ? theme.spacing(1) : 0,
        }}
    >
        <Button
            disableElevation
            size="small"
            onClick={onToggle}
            aria-expanded={isDataGridVisible}
            endIcon={
                isDataGridVisible ? (
                    <KeyboardArrowUpIcon />
                ) : (
                    <KeyboardArrowDownIcon />
                )
            }
            sx={{
                borderRadius: 100,
                paddingInline: theme.spacing(1),
                paddingBlock: 0,
                minWidth: "unset",
                minHeight: "unset",
                height: "22px",
                fontSize: 11,
                lineHeight: 1,
                textTransform: "none",
                color: theme.palette.gray[700],
                backgroundColor: theme.palette.gray[100],
                "&:hover": {
                    backgroundColor: theme.palette.gray[200],
                },
                "& .MuiButton-endIcon": {
                    marginLeft: theme.spacing(0.25),
                    marginRight: theme.spacing(-0.25),
                },
                "& .MuiButton-endIcon .MuiSvgIcon-root": {
                    fontSize: "14px",
                },
            }}
        >
            {isDataGridVisible ? "Hide" : "Show"}
        </Button>
    </Grid>
);
